import * as React from 'react';
import { FilterBox } from './FilterBox';
import { TagSearchInput } from './TagSearchInput';
import { Tag, SearchQuery } from '../../../models';
import { TagFilterGroup } from '../../../containers/SearchPage';
import './style.css';

export interface SearchFormProps {
  disabled: boolean;
  query: SearchQuery;
  searchableTags: Array<Tag>;
  tagFilterGroups: Array<TagFilterGroup>;
  onAddSearchTag: (tag: Tag) => void;
  onRemoveSearchTag: (tag: Tag) => void;
}

export interface SearchFormState {
  /* empty*/
}

export class SearchForm extends React.Component<
  SearchFormProps,
  SearchFormState
> {
  render() {
    const { onAddSearchTag, onRemoveSearchTag } = this.props;
    const showFilters = this.shouldShowTagFilters();
    const { available, selected } = this.getSearchTagSets();

    return (
      <div className="search-form">
        {showFilters ? (
          <div className="search-filter-box-wrapper">
            {this.getFilterBoxes()}
          </div>
        ) : null}
        <div className="tag-search-wrapper">
          <TagSearchInput
            available={available}
            selected={selected}
            onAddSearchTag={onAddSearchTag}
            onRemoveSearchTag={onRemoveSearchTag}
          />
        </div>
      </div>
    );
  }

  private shouldShowTagFilters = (): boolean => {
    const { tagFilterGroups } = this.props;

    return tagFilterGroups.length
      ? tagFilterGroups.every(tagFilterGroup => !!tagFilterGroup.tags.length)
      : false;
  };

  private getFilterBoxes = (): Array<JSX.Element> => {
    const {
      disabled,
      query,
      tagFilterGroups,
      onAddSearchTag,
      onRemoveSearchTag
    } = this.props;

    return tagFilterGroups.map((tagFilterGroup: TagFilterGroup, index) => (
      <FilterBox
        disabled={disabled}
        key={`tag-filter-box-${index}`}
        tags={tagFilterGroup.tags}
        title={tagFilterGroup.title}
        selectedTags={query.tags}
        onChange={(tag, checked) =>
          checked ? onAddSearchTag(tag) : onRemoveSearchTag(tag)
        }
      />
    ));
  };

  private getSearchTagSets = (): {
    available: Array<Tag>;
    selected: Array<Tag>;
  } => {
    const { query, searchableTags } = this.props;
    const available: Array<Tag> = [];
    const selected: Array<Tag> = [];

    for (const tag of searchableTags) {
      if (query.tags.some(queryTag => queryTag.id === tag.id)) {
        selected.push(tag);
      } else {
        available.push(tag);
      }
    }

    return {
      available,
      selected
    };
  };
}

export default SearchForm;



// WEBPACK FOOTER //
// ./src/app/components/Search/SearchForm/index.tsx